import { createSlice } from "@reduxjs/toolkit";

// LABEL LOCALES
import EnglishLabels from "../controller/lablelocales/English";
import TamilLabels from "../controller/lablelocales/Tamil";
import HindiLabels from "../controller/lablelocales/Hindi";
import MalayalamLabels from "../controller/lablelocales/Malayalam";
import TeluguLabels from "../controller/lablelocales/Telugu";
import KannadaLabels from "../controller/lablelocales/Kannada";

// ERROR LOCALES
import EnglishErrors from "../controller/errorlocales/English";
import TamilErrors from "../controller/errorlocales/Tamil";
import HindiErrors from "../controller/errorlocales/Hindi";
import MalayalamErrors from "../controller/errorlocales/Malayalam";
import TeluguErrors from "../controller/errorlocales/Telugu";
import KannadaErrors from "../controller/errorlocales/Kannada";

// 🔹 Read saved language
const savedLang = localStorage.getItem("appLanguage") || "en";

// 🔹 Helper function to get translations based on language
const getTranslations = (lang) => {
  switch (lang) {
    case "ta":
      return { labels: TamilLabels, errors: TamilErrors };
    case "hi":
      return { labels: HindiLabels, errors: HindiErrors };
    case "ml":
      return { labels: MalayalamLabels, errors: MalayalamErrors };
    case "te":
      return { labels: TeluguLabels, errors: TeluguErrors };
    case "kn":
      return { labels: KannadaLabels, errors: KannadaErrors };
    default:
      return { labels: EnglishLabels, errors: EnglishErrors };
  }
};

// 🔹 Initialize with correct language and translations
const initialState = {
  language: savedLang,
  translations: getTranslations(savedLang),
};

const languageSlice = createSlice({
  name: "language",
  initialState,
  reducers: {
    switchLanguage: (state, action) => {
      const newLang = action.payload;
      state.language = newLang;
      state.translations = getTranslations(newLang);
    },
  },
});

export const { switchLanguage } = languageSlice.actions;
export default languageSlice.reducer;
